import useRemoteLogger from 'AppShell/Microfrontend/useRemoteLogger';
import AppBridge from 'AppShell/appBridge/AppBridge';

export const useAppBridge = (remoteName: string) => {
    const remoteLogger = useRemoteLogger(remoteName);
    return AppBridge.getInstance(remoteLogger);
};
